<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

  <!-- Section: 10+ Années -->
  <div class="years-section">
    <div class="years-content">
      <div class="years-number">10+</div>
      <div class="years-label">Années</div>
      <p class="years-description">
        Brokins a <strong class="highlight-purple">plus d'une décennie</strong> d'expériences dans l'accompagnement 
        de ses clients dans la sélection et l'achat de leurs assurances.
      </p>
    </div>
  </div>

  <!-- Section: Nominations et Reconnaissances -->
  <div class="content-section nominations-section">
    <div class="section-text">
      <h2>Nominations et Reconnaissances</h2>
      <p>
        Grâce à un sens de l'écoute rare, un <strong class="highlight-purple">service de conseil unique</strong>, et une <strong class="highlight-purple">connaissance parfaite des produits et du marché</strong>, l'équipe 
        Brokins a remporté de nombreux concours. Depuis son lancement, Brokins a comme principal objectif de performer 
        dans les domaines de <strong class="highlight-purple">l'assurance dommages aux biens</strong> et <strong class="highlight-purple">la protection sociale</strong> par le nombre de français assurés, 
        ce qui lui a permis d'être classé comme l'un des 3 premiers courtiers en <strong class="highlight-purple">assurance-crédit</strong> 
        en France. Plus récemment, Brokins a été classé comme faisant partie du <strong class="highlight-purple">TOP10 en assurance construction</strong>. Au cours des trois dernières années, de nombreux clients assurance, particuliers et chefs d'entreprises ont 
        clairement exprimés leur satisfaction à travailler avec Brokins. Vous trouverez plus d'informations 
        sur tout cela dans nos pages <strong class="highlight-purple">Avis Clients</strong> et <strong class="highlight-purple">Blog</strong>.
      </p>
    </div>
    <div class="section-image">
      <img src="assets/static_pages_images/Page%20Histoire-Nominations%20et%20Reconnaissances.jpg" alt="Nominations et Reconnaissances">
    </div>
  </div>

  <!-- Section: Notre Histoire -->
  <div class="content-section histoire-section">
    <div class="section-image">
      <img src="assets/static_pages_images/Page%20Histoire-Notre%20Histoire.jpg" alt="Notre Histoire">
    </div>
    <div class="section-text">
      <h2>Notre Histoire</h2>
      <p>
        Notre objectif est de <strong class="highlight-purple">changer la manière dont les contrats d'assurance 
        sont vendus aux français</strong> et, ce faisant, de rendre la souscription la plus claire et la plus simple possible. Avant de créer 
        Brokins, l'équipe a travaillé plusieurs années dans l'industrie de l'assurance. Nous avons par conséquent une solide expérience dans le domaine et connaissons les écueils rencontrés par les clients dans l’étape de recherche, sélection et contractualisation. De nos premières années d’expériences, nous avons puisé la culture de l’effort, de la réactivité et de la rigueur technique. C’est pour cela que nous avons créé Brokins. Notre devise : Un courtier en assurance créé par des assureurs, au service des consommateurs. Nous aidons désormais les français répartis 
        <strong class="highlight-purple">partout sur le territoire (DOM – TOM compris)</strong> à s'assurer 
        correctement c'est-à-dire avec un accompagnement de conseil, un produit de qualité, et un prix juste.
      </p>
    </div>
  </div>

  <!-- Section: Expériences MultiExpertises -->
  <div class="content-section expertise-section">
    <div class="section-text">
      <h2>Expériences MultiExpertises</h2>
      <p>
        Brokins propose plus de <strong class="highlight-purple">48 produits d'assurance différents</strong>, 
        <strong class="highlight-purple">protégeant presque 4000 clients répartis partout en France et à 
        l'étranger</strong>. Cela nous permet d'avoir une excellente compréhension des besoins de nos clients 
        et de la manière dont les contrats d'assurance Professionnels et Particulier peuvent les protéger. 
        La connaissance de ces besoins, la relation unique avec les assureurs et mutuelles partenaires, la 
        <strong class="highlight-purple">maîtrise sans faille</strong> des contrats que nous proposons, permettent 
        aux conseillers Brokins de proposer <strong class="highlight-purple">un service hors du commun</strong>. 
        Nous partageons notre expertise et connaissance du marché sur <strong class="highlight-purple">notre blog</strong>.
      </p>
    </div>
    <div class="section-image">
      <img src="assets/static_pages_images/Einstein-_-Sasse-4422-1536x1222.jpg" alt="Expériences MultiExpertises">
    </div>
  </div>

</app-page-layout>
